/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */

import { Event } from 'fierry/flux';

import Time from 'fierry/util/time';

import State from 'shared/client/time/state';


export default new Event ([ State.Refresh ], (refreshNow) =>
{
  const callback = () =>
  {
    refreshNow({ time: new Date() });
  }

  const interval = window.setInterval(callback, Time.getSecondTicks());

  return () =>
  {
    window.clearInterval(interval);
  }
});
